import React, { useState, useCallback, useEffect } from 'react';

const API_URL = process.env.NODE_ENV === 'production'
  ? 'https://ferl.fyi/api'
  : 'http://localhost:3001/api';

function MetricsPage() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    company_name: '',
    min_rating: '',
    min_reviews: '',
    sort_by: 'overall_rating',
    sort_order: 'DESC',
  });

  const fetchCompanies = useCallback(async () => {
    setLoading(true);
    setError(null);
    const queryParams = new URLSearchParams(filters);
    try {
      const response = await fetch(`${API_URL}/companies?${queryParams}`);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      setCompanies(data);
    } catch (err) {
      console.error('Error fetching companies:', err);
      setError('Failed to load companies. Please try again later.');
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => { fetchCompanies(); }, [fetchCompanies]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const fmt = (v) => (v ? Number(v).toFixed(1) : 'N/A');

  return (
    <div className="jobs-panel">
      <header className="jobs-page-topbar">
        <span className="jobs-page-title">Company Metrics</span>
      </header>

      <div className="jobs-page">
      <div className="filters">
        <input type="text" name="company_name" placeholder="Filter by company name" value={filters.company_name} onChange={handleFilterChange} />
        <input type="number" name="min_rating" placeholder="Min rating" min="0" max="5" step="0.1" value={filters.min_rating} onChange={handleFilterChange} />
        <input type="number" name="min_reviews" placeholder="Min reviews" min="0" value={filters.min_reviews} onChange={handleFilterChange} />
        <select name="sort_by" value={filters.sort_by} onChange={handleFilterChange}>
          <option value="overall_rating">Overall Rating</option>
          <option value="number_of_reviews">Number of Reviews</option>
          <option value="career_growth">Career Growth</option>
          <option value="work_life_balance">Work Life Balance</option>
          <option value="compensation_benefits">Compensation/Benefits</option>
          <option value="company_culture">Company Culture</option>
          <option value="management">Management</option>
        </select>
        <select name="sort_order" value={filters.sort_order} onChange={handleFilterChange}>
          <option value="DESC">Highest First</option>
          <option value="ASC">Lowest First</option>
        </select>
      </div>

      {loading && <div className="loading">Loading companies...</div>}
      {error && <div className="error">{error}</div>}
      {!loading && !error && companies.length === 0 && (
        <div className="empty-state">No companies found matching your criteria.</div>
      )}
      {!loading && !error && companies.length > 0 && (
        <div className="companies-table">
          <table>
            <thead>
              <tr>
                <th>Company</th><th>Rating</th><th>Reviews</th>
                <th>Career Growth</th><th>Work/Life</th><th>Benefits</th>
                <th>Culture</th><th>Management</th>
              </tr>
            </thead>
            <tbody>
              {companies.map((company) => (
                <tr key={company.id}>
                  <td>{company.company_name}</td>
                  <td>{fmt(company.overall_rating)}</td>
                  <td>{company.number_of_reviews}</td>
                  <td>{fmt(company.career_growth)}</td>
                  <td>{fmt(company.work_life_balance)}</td>
                  <td>{fmt(company.compensation_benefits)}</td>
                  <td>{fmt(company.company_culture)}</td>
                  <td>{fmt(company.management)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      </div>
    </div>
  );
}

export default MetricsPage;
